import styled from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'

interface BandProps {
  id: string
  active: boolean
  cartLoading: boolean
  animationDelay: number
  progress: number
}

/** Represents a single delivery price band in the UI. Indicates active state / progress, and handles animation timing and loading state. */
const Band: React.FC<BandProps> = ({
  active,
  cartLoading,
  animationDelay,
  progress
}) => {
  return (
    <Container>
      <ProgressBar
        active={active}
        cartLoading={cartLoading}
        animationDelay={animationDelay}
        progress={progress}
        data-testid='band-progress-bar'
      />
    </Container>
  )
}

const Container = styled.div({
  height: '5px',
  backgroundColor: '#F0F0F0',
  flex: '1 1 0',
  position: 'relative',
  overflow: 'hidden',
  borderRadius: '2px'
})

const ProgressBar = styled.div<
  StyledHTMLElement & {
    active: boolean
    cartLoading: boolean
    progress: number
    animationDelay: number
  }
>(({ theme, active, cartLoading, progress, animationDelay }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100%',
  backgroundColor: theme.colors.primary,
  opacity: 0.5,
  width: '0%',
  transition: 'width 0.6s ease-in-out, opacity 0.3s ease-in-out',
  transitionDelay: `${animationDelay}ms`,
  ...(cartLoading && {
    transition: 'none',
    transitionDelay: '0s'
  }),
  ...(active &&
    progress === 0 && {
      width: '0%'
    }),
  ...(progress > 0 &&
    progress < 100 && {
      width: `${progress}%`,
      opacity: 0.5
    }),
  ...(progress === 100 && {
    width: '100%',
    opacity: 1
  })
}))

export default Band
